import { Checkbox, Divider } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React from 'react';
import styles from './DocketAlertItem.module.scss';
import { AlertOption } from '../../../../models/DocketAlerts';

const cx = classNames.bind(styles);

interface DocketAlertItemProps<TValue extends string> {
  title: React.ReactNode;
  options: AlertOption<TValue>[];
  selectedOption: TValue;
  onOptionSelect: (alert: TValue) => void;
  dataTestPrefix: string;
}

const DocketAlertItem = <TValue extends string>(props: DocketAlertItemProps<TValue>): React.ReactElement => {
  const { title, options, selectedOption, onOptionSelect, dataTestPrefix } = props;

  return (
    <div className={cx('body')}>
      <div className={cx('content')}>
        <div className={cx('header')}>
          <div className={cx('title')}>{title}</div>
        </div>
      </div>
      <div className={cx('options')}>
        {options.map((option) => (
          <div key={option.value}>
            <Checkbox
              className={cx('radio-select')}
              radio
              dataTestId={`${dataTestPrefix}-alerts-toggle`}
              label={option.label}
              name={`${dataTestPrefix}-alert-option`}
              checked={selectedOption === option.value}
              onChange={() => onOptionSelect(option.value)}
            />
          </div>
        ))}
      </div>

      <Divider className={cx('divider')} />
    </div>
  );
};

export default DocketAlertItem;
